import { STEPS as progressGr16_202307Steps, STEP_FIELDS as progressGr16_202307StepFields, FIELD_LABELS as progressGr16_202307FieldLabels } from "../reports/progress-gr1-6-2023-07/steps";
import { STEPS as provincialGr16_202309Steps, STEP_FIELDS as provincialGr16_202309StepFields, FIELD_LABELS as provincialGr16_202309FieldLabels } from "../reports/provincial-gr1-6-2023-09/steps";
import { STEPS as provincialGr78_202309Steps, STEP_FIELDS as provincialGr78_202309StepFields, FIELD_LABELS as provincialGr78_202309FieldLabels } from "../reports/provincial-gr7-8-2023-09/steps";

// Converts steps.js exports into the { step, key, label }[] format used by Class.jsx.
const buildLabelArray = (steps, stepFields, fieldLabels) =>
  steps.flatMap((step) =>
    (stepFields[step.id] ?? []).map((key) => ({
      step: step.title,
      key,
      label: fieldLabels[key] ?? key,
    }))
  );

export const REPORT_FIELD_LABELS = {
  pgrc1to6_2023_07: buildLabelArray(progressGr16_202307Steps, progressGr16_202307StepFields, progressGr16_202307FieldLabels),
  pvrc1to6_2023_09: buildLabelArray(provincialGr16_202309Steps, provincialGr16_202309StepFields, provincialGr16_202309FieldLabels),
  pvrc7to8_2023_09: buildLabelArray(provincialGr78_202309Steps, provincialGr78_202309StepFields, provincialGr78_202309FieldLabels),
};
